export const gConfigCheckerStates = Object.freeze({
  VALID: 'VALID',
  INVALID: 'INVALID',
  UNCHECKED: 'UNCHECKED',
  UNKNOWN: 'UNKNOWN'
});
